import { useState, useEffect } from 'react';
import apiClient from '../../../api/apiClient';
import userApi from '../../../api/userApi';

export const useLayoutData = () => {
  const [user, setUser] = useState(null);
  const [notifications, setNotifications] = useState([]);

  useEffect(() => {
    loadUser();
    loadNotifications();
  }, []);

  const loadUser = async () => {
    try {
      const currentUser = await userApi.getProfile();
      setUser(currentUser);
    } catch (error) {
      // User not logged in
    }
  };

  const loadNotifications = async () => {
    try {
      const data = await apiClient.get('/notifications?is_read=false&limit=5');
      setNotifications(data.notifications || data || []);
    } catch (error) {
      // Error loading notifications
    }
  };

  return { user, notifications };
};
